var _react_refresh_temp_1;
_react_refresh_temp_1 = $RefreshSig$();
/* eslint-disable @typescript-eslint/no-unsafe-assignment -- WIP*/
import { useEffect, useMemo } from 'react';
import { useFormEditContext, useFormRoot } from '../../providers';
import { useForm } from '../useForm/useForm';
import { useFieldDOM, useFieldErrors, useFieldParent, useFieldReset, useFieldState, useFieldValidate, } from './hooks';
export const useField = ({ autoFocus, dependencyExtractor, 
// TODO: https://lucidlink.atlassian.net/browse/LUCID-16512 -- Add unit tests for revalidating a field when it toggles from disabled to enabled
disabled, formatter, initialValue, name, onBlur, onFocus, sideEffect, validationDebounceTime = 0, validator, }) => {
    _react_refresh_temp_1();
    const { methods: rootMethods } = useFormRoot();
    const { isEdit } = useFormEditContext();
    const { methods: parentMethods } = useForm();
    const { getFieldId } = parentMethods;
    const fieldId = useMemo(() => {
        const parentId = getFieldId();
        return parentId ? `${parentId}.${name}` : name;
    }, [getFieldId, name]);
    const { blur, focus, resetState, setTouch, setValidity, setValue, state, triggerValidation, updatedDependency, updatedInitialValue, } = useFieldState({
        dependencyExtractor,
        fieldId,
        formatter,
        disabled,
        initialValue,
    });
    useFieldErrors({ fieldErrors: state.errors, fieldId });
    useFieldParent({
        fieldId,
        isValid: state.isValid,
        isValidating: state.isValidating,
        name,
        setTouch,
        value: state.value,
    });
    const { fieldRef, onBlurHandler, onChangeHandler, onFocusHandler } = useFieldDOM({
        autoFocus,
        blur,
        fieldId,
        focus,
        isTouched: state.isTouched,
        onBlur,
        onFocus,
        setValue,
        updatedInitialValue,
    });
    useFieldReset({ fieldId, resetState, updatedInitialValue });
    useFieldValidate({
        isValidating: state.isValidating,
        setValidity,
        updatedDependency,
        validationDebounceTime,
        validator,
        value: state.value,
    });
    useEffect(() => {
        if (sideEffect) {
            sideEffect({
                dependencyValue: updatedDependency,
                methods: { form: parentMethods, root: rootMethods },
                value: state.value,
            });
        }
    }, [state.value, updatedDependency]);
    return {
        dependencyValue: updatedDependency,
        fieldId,
        fieldRef,
        isEdit,
        onBlurHandler,
        onChangeHandler,
        onFocusHandler,
        updatedInitialValue,
        ...state,
        triggerValidation,
    };
};
_react_refresh_temp_1(useField, "bDCB3V5d1ULKpr3Vr1aZLS0vkSY=", false, () => [useFormRoot, useFormEditContext, useForm, useFieldState, useFieldErrors, useFieldParent, useFieldDOM, useFieldReset, useFieldValidate]);
